import React from 'react';
import Panel from '../../layout/Panel';
import { CompareArrows as DiffIcon } from '@mui/icons-material';
import DiffCore from './DiffCore';

export default function Diff() {
  return (
    <Panel 
      title="Diff"
      icon={<DiffIcon />}
      contentSx={{ p: 2 }}
    >
      <DiffCore />
    </Panel>
  );
}
